export default __webpack_public_path__ + "static/media/bg-college.46c02a1c.webp";